var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionDnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 5.50033C9.16699 4.99407 8.75659 4.58366 8.25032 4.58366C7.74406 4.58366 7.33366 4.99407 7.33366 5.50033C7.33366 6.00659 7.74406 6.41699 8.25032 6.41699C8.75659 6.41699 9.16699 6.00659 9.16699 5.50033Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 5.50033C14.667 4.99407 14.2566 4.58366 13.7503 4.58366C13.2441 4.58366 12.8337 4.99407 12.8337 5.50033C12.8337 6.00659 13.2441 6.41699 13.7503 6.41699C14.2566 6.41699 14.667 6.00659 14.667 5.50033Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 11.0003C9.16699 10.4941 8.75659 10.0837 8.25032 10.0837C7.74406 10.0837 7.33366 10.4941 7.33366 11.0003C7.33366 11.5066 7.74406 11.917 8.25032 11.917C8.75659 11.917 9.16699 11.5066 9.16699 11.0003Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 11.0003C14.667 10.4941 14.2566 10.0837 13.7503 10.0837C13.2441 10.0837 12.8337 10.4941 12.8337 11.0003C12.8337 11.5066 13.2441 11.917 13.7503 11.917C14.2566 11.917 14.667 11.5066 14.667 11.0003Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 16.5003C9.16699 15.9941 8.75659 15.5837 8.25033 15.5837C7.74406 15.5837 7.33366 15.9941 7.33366 16.5003C7.33366 17.0066 7.74406 17.417 8.25033 17.417C8.75659 17.417 9.16699 17.0066 9.16699 16.5003Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 16.5003C14.667 15.9941 14.2566 15.5837 13.7503 15.5837C13.2441 15.5837 12.8337 15.9941 12.8337 16.5003C12.8337 17.0066 13.2441 17.417 13.7503 17.417C14.2566 17.417 14.667 17.0066 14.667 16.5003Z",
    stroke: "#8493B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionDnd);
export default __webpack_public_path__ + "static/media/optionDND.e5d008b82c9467a1624532b7f2ecab5b.svg";
export { ForwardRef as ReactComponent };